import {useMemo, useState} from 'react';

// Chakra
import {
  Table,
  Tbody,
  Tr,
  Td,
  useColorModeValue,
  Thead,
} from '@chakra-ui/react';

import Card from 'components/Card/Card';
import {apiService} from '../../../../services/ApiService';
import {useQuery} from 'react-query';

export default function GiveawayEntries({ giveawayId }) {
  const textColor = useColorModeValue('gray.700', 'white');
  const [giveawayEntries, setGiveawayEntries] = useState([]);

  useQuery({
    queryKey: ['giveawayEntriesCount', giveawayId],
    refetchOnWindowFocus: false,
    queryFn: async () => {

      const response = await apiService.getGiveawaysEntriesCount({id: giveawayId});
      setGiveawayEntries(response.data);
      return true;
    },
    retry: false
  });

  const totalEntryAmount = useMemo(()=> giveawayEntries.reduce((sum, item) => sum + (+item.entryAmount || 0), 0),[giveawayEntries]) ;

  return (
    <Card padding="24px" mb="40px">
      <Table color={textColor}>
        <Thead>
          <Tr>
            <Td>Entry type</Td>
            <Td>Amount</Td>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td>Total</Td>
            <Td>{totalEntryAmount}</Td>
          </Tr>
          {giveawayEntries.map((el) => (
            <Tr key={el.entryType}>
              <Td>{el.entryType}</Td>
              <Td>{el.entryAmount}</Td>
            </Tr>
          ))}
          <Tr></Tr>
        </Tbody>
      </Table>
    </Card>
  );
}
